var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wish-list-masonry relative p-2 tablet-landscape:p-4",attrs:{"id":"wish-list","tabindex":"-1"}},[_vm._l((_setup.internalAllSortedPosts),function(post,index){return [_c(_setup.SurfacePost,{key:post.cid,class:{
        // Use this over v-show as it sometimes has trouble with reactivity on the shouldDisplay call
        hidden: !_setup.shouldDisplayPost(post.cid),
      },style:({
        width: _setup.postWidth,
        maxWidth: _setup.maxPostWidth + 'px',
      }),attrs:{"index":index,"post":post,"post-reaction-ids":_vm.reactionIdsByPostId[post.id],"post-comment-ids":_vm.commentIdsByPostId[post.id],"lazy-render":_setup.isAppUsing('lazyRenderPosts'),"min-post-height":_setup.minPostHeight,"min-post-width":_setup.minPostWidth}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }